const initState = {
	fetching: false,
	fetched: false,
	error: null,
	payload: {},
	saved: false,
	message: null,
	cycle: {},
	isDeleted: false,
};

const cycleReducer = (state = initState, action) => {
	switch (action.type) {
		case 'CYCLE_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'CYCLE_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'CYCLE_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				payload: action.payload.data,
				error: null,
				saved: false,
				isDeleted: false
			};
		case 'SAVE_CYCLE_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'SAVE_CYCLE_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'SAVE_CYCLE_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'GET_CYCLE_PENDING':
			return {
				...state,
				fetching: true
			};
		case 'GET_CYCLE_REJECTED':
			
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'GET_CYCLE_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				cycle: action.payload.data,
				error: null,
				saved: false,
			};
		case 'UPDATE_CYCLE_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'UPDATE_CYCLE_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false,
				fetched: false
			};
		case 'UPDATE_CYCLE_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				saved: true
			};
		case 'DELETE_CYCLE_PENDING' : 
			return {
				...state,
				fetching: true
			};
		case 'DELETE_CYCLE_REJECTED' :
			if (action.payload.response.status === 401) {
				localStorage.removeItem('token');
			}
			
			return {
				...state,
				error: action.payload.response,
				fetching: false
			};
		case 'DELETE_CYCLE_FULFILLED':
			return {
				...state,
				fetching: false,
				fetched: true,
				message: action.payload.data.message,
				error: null,
				isDeleted: true
			};
		default:
			return state;
	}
};

export default cycleReducer;
